import { OnInit, Input, Component } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { Payment } from '@app/shared/models/payment';
import { PaymentService, CasePaymentUriBuilderParams } from '@app/core/services/case-payment.service';
import { BaseWithIdList, BaseList } from '@app/shared/models/list';
import { PaymentType } from '@app/shared/models/payment-type';
import { PaymentTypeService, PaymentTypeBuilderUriParams } from '@app/core/services/payment-type.service';
import { PaymentReceiverService, PaymentReceiverBuilderUriParams } from '@app/core/services/payment-receiver.service';
import { PaymentReceiver } from '@app/shared/models/payment-receiver';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { PaymentDialogComponent } from '@app/modules/case/components/payment-dialog/payment-dialog.component';

@Component({
    selector: 'case-lawyer-payment',
    templateUrl: './case-lawyer-payment.component.html',
    styleUrls: ['./case-lawyer-payment.component.scss']
})
export class CaseLawyerPaymentComponent extends BaseWithBundleComponent implements OnInit {

    @Input()
    public caseId: string;

    public paymentList: BaseWithIdList<Payment>;
    public paymentTypes: PaymentType[];
    public paymentReceivers: PaymentReceiver[];

    constructor(protected componentServiceBundle: ComponentServiceBundle,
        protected paymentService: PaymentService,
        protected paymentTypeService: PaymentTypeService,
        protected paymentReceiverService: PaymentReceiverService) {
        super(componentServiceBundle);
    }

    public ngOnInit() {

        this.paymentTypeService.query(new PaymentTypeBuilderUriParams())
            .subscribe((result: BaseList<PaymentType>) => {
                this.paymentTypes = result.items;
            }, err => this.handleError(err));

        this.paymentReceiverService.query(new PaymentReceiverBuilderUriParams())
            .subscribe((result: BaseList<PaymentReceiver>) => {
                this.paymentReceivers = result.items;
            }, err => this.handleError(err));

        this.paymentService.query(this.generateUriBuilderParams())
            .subscribe(result => {
                this.paymentList = result;
            }, err => this.handleError(err));

    }

    public isEditable(): boolean {
        return !this.disabled && !this.readonly;
    }

    public createPayment(): void {
        const dialogRef = this.dialog.open(PaymentDialogComponent, {
            width: '800px',
            disableClose: true,
            autoFocus: false,
            data: {
                paymentTypes: this.paymentTypes,
                paymentReceivers: this.paymentReceivers
            }
        });

        dialogRef.afterClosed()
                 .subscribe(newPayment => {
            if (newPayment) {
                newPayment.case_id = this.caseId;

                this.paymentService.create(this.generateUriBuilderParams(), newPayment)
                                   .subscribe(result => {
                        this.paymentList.addItem(result);
                }, err => this.handleError(err));
            }
        });
    }

    public removePayment(paymentToRemove: Payment): void {
        this.showSimpleConfirmDialog(
            marker('common.dialog.delete.title'),
            this.translateService.instant(marker('common.dialog.delete.text'), { 'name': this.translateService.instant(marker('payment')) }))
            .subscribe(result => {
                if (result) {
                    this.paymentService.delete(this.generateUriBuilderParams(paymentToRemove))
                        .subscribe(deleteResult => {
                            this.paymentList.removeItem(paymentToRemove);
                        });
                }
            });
    }

    protected generateUriBuilderParams(payment?: Payment): CasePaymentUriBuilderParams {
        return new CasePaymentUriBuilderParams(this.caseId, payment);
    }
}
